import React from "react";
import trim from "lodash/trim";
import Icon from "./Icon";
const ExternalLink = ({ children, className = "", href = "", iconName = "open_in_new", target = "_blank" }) => {
  const content = /* @__PURE__ */ React.createElement("span", null, children, "\xA0", /* @__PURE__ */ React.createElement(Icon, { name: iconName }));
  if (trim(href) === "") {
    return content;
  }
  return /* @__PURE__ */ React.createElement("a", { href, target, className, rel: "noopener noreferrer" }, content);
};
export default ExternalLink;
